import { AxiosRequestConfig } from 'axios';
import { useMutation } from 'react-query';
import { axiosDefaultApi } from 'src/lib/axios'
import { MutationConfig} from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';

const header: AxiosRequestConfig = {responseType: "arraybuffer"}

const getBillingSummaryDownloadCsv = ( {data} : {data: IBillingSummarySearchForm}): Promise<string> => {
  return axiosDefaultApi.post(`api/Billing/ExportToCSV`, data, header);
};

type QueryFnType = typeof getBillingSummaryDownloadCsv;

type UseBillingSummaryDownloadCsvOptions = {
  data: IBillingSummarySearchForm;
  config?: MutationConfig<QueryFnType>;
};

export const useBillingSummaryDownloadCsv = ({ config }: UseBillingSummaryDownloadCsvOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();

  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στο κατέβασμα του αρχείου των χρεώσεων.`, 500);
      setIsNotificationVisible(true);
      console.error('An error occurred while downloading billing summary csv:', error);
    },
    onSuccess: () => {
      console.log('Billing summary report csv downloaded successfully.');
    },
    ...config,
    mutationFn: getBillingSummaryDownloadCsv,
  })
}